module.exports = __webpack_public_path__ + "static/media/good-therapy-band-logo-white.b3c1a1c6.png";